import './style';
import App from './components/app';
import __CAAS__ from './sdk/__caas__';

window.__CAAS__ = __CAAS__;

export default App;
